export const apis = {
  api: {
    cabecalhoAPI: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/cabecalho',
    informes3API: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/informes3',
    informes2API: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/informes2',
    informes1API: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/informes1',
    publicacoesAPI: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/publicacoes',
    sobreAPI: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/sobre',
    equipeAPI: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/equipe',
    equipecapaAPI: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/equipecapa',
    amartyaAPI: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/amartya',
    rodapeAPI: 'http://capacidadeshumanas.org/oichsitev3/wp-json/oich/rodape'
  }
}
